<template>
  <div
    id="main-grid"
    class="grid simple main borderRadius12px"
    style="background: #e5e9ec"
  >
    <div class="well form-group" style="background: #e5e9ec">
      <!-- title -->
      <div class="grid-title no-border borderTop" style="display: flex; justify-content: space-between; align-items: center; padding-right: 20px;">
        <h4 style="padding-left: 6px">{{ i18nValues["eventAdmin"] }}</h4>
        <el-button
          v-if="componentsMap.get('event_create')"
          icon="fas fa-plus"
          size="small"
          class="btn-primary"
          @click="add()"
        >
          {{ i18nValues["add"] }}
        </el-button>
      </div>

      <!-- form -->
      <div class="grid-body no-border borderBottom">
        <el-form v-loading="loading != 0">
          <div class="filters-wrapper">
            <div class="filters-row">
              <!-- search by name -->
              <el-form-item :label="i18nValues['event']" prop="name">
                <el-input
                  v-model="filter.name"
                  :placeholder="i18nValues['event']"
                ></el-input>
              </el-form-item>

              <!-- search button  -->
              <el-button
                @click="retrieveEventsBySearch()"
                icon="fas fa-search"
                id="searchButton"
                size="small"
                class="btn-primary"
              >
                {{ i18nValues["search"] }}
              </el-button>
            </div>
          </div>

          <!-- table -->
          <el-form-item prop="events">
            <div style="margin:5 auto;padding:15px; width: 100%;">
              <el-table
                :key="tableSortKey"
                :data="EventsSubList"
                id="EventsTable"
                class="table table-hover"
                align="left"
                with="20%"
                :empty-text="i18nValues['noDataAvailable']"
                :default-sort="tableDefaultSort"
                stripe
                @sort-change="handleSortChange"
              >
                <!-- Event Name -->
                <el-table-column
                  prop="name"
                  :label="i18nValues['name']"
                  width="75"
                  align="left"
                  sortable
                ></el-table-column>

                <!-- Event Detailed Trait -->
                <el-table-column
                  prop="detailedTrait"
                  :label="i18nValues['detailedTrait']"
                  width="250"
                  align="left"
                  sortable
                ></el-table-column>

                <el-table-column width="75" align="center"></el-table-column>

                <!-- EDIT/DELETE -->
                <el-table-column width="90" align="right">
                  <template slot-scope="scope">
                    <el-button
                      v-if="isReadOnly()"
                      fixed="right"
                      class="text-info"
                      icon="fa fa-eye"
                      size="small"
                      :title="i18nValues['view']"
                      @click="edit(scope.row.id)"
                    ></el-button>

                    <el-button
                      v-if="componentsMap.get('event_modification')"
                      class="text-info"
                      icon="fas fa-edit"
                      size="small"
                      :title="i18nValues['edit']"
                      @click="edit(scope.row.id)"
                    ></el-button>

                    <el-button
                      v-if="componentsMap.get('event_delete')"
                      class="text-danger"
                      icon="fas fa-times"
                      size="small"
                      :title="i18nValues['remove']"
                      @click="deleteEvent(scope.row.id)"
                    ></el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div v-if="90 > 10" style="height: 15px"></div>
              <div class="pagination-bar">
                <PaginationFunctional
                  ref="pagination"
                  sublistName="EventsSubList"
                  :fullList="EventsList"
                  :tableSize="20"
                  :tableIndexInitial="initialPage"
                  @paginationChange="paginationChange"
                  @currentIndexPagination="setCurrentPage"
                  class="text-center"
                />
                <div v-if="EventsList.length > 0" class="results-info">
                  <p>
                    {{ i18nValues["showing"] || "Showing" }} {{ startIndexDisplay }}–{{ endIndexDisplay }} {{ i18nValues["of"] || "of" }} {{ totalRecords }} {{ i18nValues["results"] || "results" }}
                  </p>
                </div>
              </div>
          </div>
          </el-form-item>

        </el-form>

      </div>
    </div>
  </div>
</template>

<script>
import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
import PaginationFunctional from "@/components/PaginationFunctional.vue";
export default {
  name: "EventAdmin",
  created() {
    this.restoreFromQuery();
    this.runInitialSearchIfFiltersPresent();
    this.retrieveEventCount();
  },

  components: {
    PaginationFunctional,
  },

  computed: {
    loading: get("event/loading"),

    // Pagination helpers for results label
    currentPage() {
      if (this.$refs && this.$refs.pagination && this.$refs.pagination.tableIndex) {
        return this.$refs.pagination.tableIndex;
      }
      return this.initialPage || 1;
    },
    pageSize() {
      return 20; // Keep in sync with PaginationFunctional :tableSize
    },
    totalRecords() {
      if (Array.isArray(this.EventsList)) {
        return this.EventsList.length;
      }
      return typeof this.cantidad === "number" ? this.cantidad : 0;
    },
    startIndexDisplay() {
      if (this.totalRecords === 0) return 0;
      const start = (this.currentPage - 1) * this.pageSize + 1;
      return Math.min(start, this.totalRecords);
    },
    endIndexDisplay() {
      if (this.totalRecords === 0) return 0;
      const end = this.currentPage * this.pageSize;
      return Math.min(end, this.totalRecords);
    },

    tableDefaultSort() {
      if (this.sortProp && this.sortOrder) {
        return { prop: this.sortProp, order: this.sortOrder };
      }
      return {};
    },

    tableSortKey() {
      // Key changes when sort changes, forcing table to re-render with new default-sort
      return `${this.sortProp || 'none'}-${this.sortOrder || 'none'}`;
    },
  },

  props: {
    componentsMap: {},
  },

  data() {
    return {
      filter: {},

      EventsList: [],
      EventsSubList: [],
      cantidad: 100,
      initialPage: 1,
      sortProp: null,
      sortOrder: null,
      isUpdatingRoute: false,
    };
  },

  methods: {
    retrieveEvents({ preservePage = false, targetPage = null } = {}) {
      this.$store.dispatch("event/retrieveEvents").then((res) => {
        let processedList = res;
        // Apply sorting if sort parameters are present (before setting EventsList)
        if (this.sortProp && this.sortOrder && this.$refs && this.$refs.pagination) {
          const sorted = this.$refs.pagination.handleSortChangePagination({
            prop: this.sortProp,
            order: this.sortOrder
          }, processedList);
          if (Array.isArray(sorted)) {
            processedList = sorted;
          }
        }
        // Set the processed list
        this.EventsList = processedList;
        
        // Sync pagination after loading - use double nextTick to ensure pagination component has processed the list
        const resolvedTarget = typeof targetPage === "number" && targetPage > 0
          ? targetPage
          : this.initialPage || 1;
        this.$nextTick(() => {
          this.$nextTick(() => {
            if (this.$refs && this.$refs.pagination && typeof this.$refs.pagination.currentChange === "function") {
              this.$refs.pagination.currentChange(resolvedTarget);
            }
          });
        });
        // Only update route query if not preserving page (to avoid overwriting URL params during initial load)
        if (!preservePage) {
          this.updateRouteQuery();
        }
        // When preservePage is true, the URL already has the correct state, so we don't update it
      });
    },

    retrieveEventsBySearch(preservePage = false) {
      if (this.filter == null || (this.filter.name == null || this.filter.name == "")) {
        this.retrieveEvents({ preservePage });
      } else {
        //console.log(this.filter);//eslint-disable-line
        this.$store
          .dispatch("event/retrieveEventsBySearch", this.filter)
          .then((res) => {
            let processedList = res;
            
            // Apply sorting if sort parameters are present
            if (this.sortProp && this.sortOrder && this.$refs && this.$refs.pagination) {
              const sorted = this.$refs.pagination.handleSortChangePagination({
                prop: this.sortProp,
                order: this.sortOrder
              }, processedList);
              if (Array.isArray(sorted)) {
                processedList = sorted;
              }
            }
            
            this.EventsList = processedList;
            
            const targetPage = preservePage ? this.initialPage || 1 : 1;
            if (!preservePage) {
              this.initialPage = 1;
            }
            
            // Sync pagination after loading
            this.$nextTick(() => {
              this.$nextTick(() => {
                if (this.$refs && this.$refs.pagination && typeof this.$refs.pagination.currentChange === "function") {
                  this.$refs.pagination.currentChange(targetPage);
                }
              });
            });
            
            // Update URL after search
            if (preservePage) {
              this.updateRouteQuery();
            } else {
              this.updateRouteQuery({ page: 1 });
            }
          });
      }
    },

    add() {
      this.$router.push({
        name: `EventEdition`,
        params: { id: "0" },
        query: this.$route.query,
      });
    },

    edit(id) {
      this.$router.push({
        name: `EventEdition`,
        params: { id: id },
        query: this.$route.query,
      });
      //console.log(this.id);//eslint-disable-line
    },

    deleteEvent(id) {
      this.$confirm(
        "Está seguro que quiere eliminar el evento?",
        "Eliminar Evento",
        {
          distinguishCancelAndClose: true,
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      ).then(() => {
        this.$store.dispatch("event/deleteEvent", id).then((res) => {
          if (res.status == "OK") {
            this.$notify.success({
              title: this.i18nValues["success"],
              message: this.i18nValues["eventDeleted"],
              position: "bottom-right",
            });
            this.runInitialSearchIfFiltersPresent();
            this.retrieveEventCount();
          } else {
            this.$notify.error({
              title: this.i18nValues["error"],
              message: this.i18nValues["eventDeletError"],
              position: "bottom-right",
            });
          }
        });
      });
    },

    retrieveEventCount() {
      this.$store
        .dispatch("event/countEvents")
        .then((res) => {
          this.cantidad = res;
        });
    },

    handleSortChange(event) {
      const nextProp = event && event.prop ? event.prop : null;
      const nextOrder = event && event.order ? event.order : null;
      const sortChanged = this.sortProp !== nextProp || this.sortOrder !== nextOrder;
      this.sortProp = nextProp;
      this.sortOrder = nextOrder;
      if (sortChanged) {
        this.EventsList = this.$refs.pagination.handleSortChangePagination(event);
        this.initialPage = 1;
        this.updateRouteQuery({
          sortProp: this.sortProp || undefined,
          sortOrder: this.sortOrder || undefined,
          page: 1,
        });
        this.$nextTick(() => {
          if (this.$refs && this.$refs.pagination && typeof this.$refs.pagination.currentChange === 'function') {
            this.$refs.pagination.currentChange(1);
          }
        });
      } else {
        this.EventsList = this.$refs.pagination.handleSortChangePagination(event);
      }
    },

    paginationChange(evt) {
      if (evt && evt.list) {
        this.EventsSubList = evt.list;
      }
      const currentIdx = this.$refs.pagination && this.$refs.pagination.tableIndex ? this.$refs.pagination.tableIndex : this.initialPage;
      this.updateRouteQuery({ page: currentIdx });
    },

    setCurrentPage(idx) {
      if (typeof idx === 'number') {
        this.updateRouteQuery({ page: idx });
      }
    },

    hasFiltersInQuery() {
      const q = this.$route.query || {};
      return !!(
        q.name ||
        // Also check component state in case query hasn't updated yet
        (this.filter && this.filter.name)
      );
    },

    runInitialSearchIfFiltersPresent() {
      if (this.hasFiltersInQuery()) {
        this.retrieveEventsBySearch(true); // preservePage = true when loading from URL
      } else {
        // Even without filters, we need to load events and preserve page/sort from URL
        this.retrieveEvents({ 
          preservePage: true, 
          targetPage: this.initialPage || 1 
        });
      }
    },

    // --- Query sync helpers ---
    restoreFromQuery() {
      const q = this.$route.query || {};
      this.filter = this.filter || {};
      if (q.name) this.filter.name = q.name;
      this.initialPage = q.page ? Number(q.page) : 1;
      this.sortProp = q.sortProp || null;
      this.sortOrder = q.sortOrder || null;
    },

    updateRouteQuery(partial) {
      const base = this.buildQueryFromState();
      const next = Object.assign({}, base, partial || {});
      const cleaned = {};
      Object.keys(next).forEach(k => {
        const v = next[k];
        if (v !== undefined && v !== null && v !== '') cleaned[k] = v;
      });
      this.isUpdatingRoute = true;
      const done = () => { this.$nextTick(() => { this.isUpdatingRoute = false; }); };
      this.$router.replace({ query: cleaned }).then(done).catch(done);
    },

    buildQueryFromState() {
      const q = {};
      if (this.filter && this.filter.name) q.name = this.filter.name;
      if (this.$refs && this.$refs.pagination && this.$refs.pagination.tableIndex) q.page = this.$refs.pagination.tableIndex;
      else if (this.initialPage) q.page = this.initialPage;
      if (this.sortProp) q.sortProp = this.sortProp;
      if (this.sortOrder) q.sortOrder = this.sortOrder;
      return q;
    },
  },
  watch: {
    $route() {
      this.restoreFromQuery();
      this.$nextTick(() => {
        // Check if filters are present in the URL and run search if needed
        if (this.hasFiltersInQuery()) {
          this.retrieveEventsBySearch(true); // preservePage = true when loading from URL
        } else {
          // Even without filters, reload events to preserve page/sort from URL
          this.retrieveEvents({ 
            preservePage: true, 
            targetPage: this.initialPage || 1 
          });
        }
      });
    }
  }
};
</script>

<style scoped>
/* Filters wrapper - single horizontal line */
.filters-wrapper {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.filters-row {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-end;
  gap: 8px;
}

.filters-row /deep/ .el-form-item {
  margin-bottom: 0;
  flex-shrink: 0;
}

/* Make inputs narrower */
.filters-row /deep/ .el-input,
.filters-row /deep/ .el-select {
  width: 140px;
}


/* Buttons in the same row, aligned to bottom */
.filters-row /deep/ .el-button {
  flex-shrink: 0;
}

/* Pagination + results inline */
.pagination-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 0 20px 10px;
  color: #606266;
}

.results-info {
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
}

.results-info p {
  margin: 0;
  font-size: 12px;
  color: #606266;
  font-weight: 500;
}
</style>
